import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
  const _component_van_tabbar = _resolveComponent("van-tabbar");
  return $setup.is_show ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_tabbar, {
    "active-color": "#13A4BF",
    route: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
      to: "/member_index"
    }, {
      icon: _withCtx(props => [_createElementVNode("img", {
        src: 'https://www.mimodental.com/assets/imgData/img/footer/' + (props.active ? 'home_s.png' : 'home.png'),
        alt: ""
      }, null, 8, _hoisted_2)]),
      default: _withCtx(() => [_cache[0] || (_cache[0] = _createElementVNode("h2", {
        style: {
          "font-size": "25px"
        }
      }, "首页", -1))]),
      _: 1,
      __: [0]
    }), _createVNode(_component_van_tabbar_item, {
      to: "/member_science_m"
    }, {
      icon: _withCtx(props => [_createElementVNode("img", {
        src: 'https://www.mimodental.com/assets/imgData/img/footer/' + (props.active ? 'kqzs_s.png' : 'kqzs.png'),
        alt: ""
      }, null, 8, _hoisted_3)]),
      default: _withCtx(() => [_cache[1] || (_cache[1] = _createElementVNode("h2", {
        style: {
          "font-size": "25px"
        }
      }, "口腔知识", -1))]),
      _: 1,
      __: [1]
    }), _createVNode(_component_van_tabbar_item, {
      to: "/member_my"
    }, {
      icon: _withCtx(props => [_createElementVNode("img", {
        src: 'https://www.mimodental.com/assets/imgData/img/footer/' + (props.active ? 'my_s.png' : 'my.png'),
        alt: ""
      }, null, 8, _hoisted_4)]),
      default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("h2", {
        style: {
          "font-size": "25px"
        }
      }, "我的", -1))]),
      _: 1,
      __: [2]
    })]),
    _: 1
  })])) : _createCommentVNode("", true);
}